import { render, staticRenderFns } from "./HomeFeedHero.vue?vue&type=template&id=580ac2ce&scoped=true"
import script from "./HomeFeedHero.vue?vue&type=script&lang=js"
export * from "./HomeFeedHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580ac2ce",
  null
  
)

export default component.exports